<template>
  <section class="flex justify-between gap-8 mt-24">
    <div class="selection-wrapper w-full flex-col self-end">
      <h1 class="text-h3 lg:text-h2 mb-8 break-all">Hello, {{ account.firstName }}</h1>
      <ProfileEditMenu :profileAccountData="profileAccountData" />
    </div>
    <div class="relative">
      <Avatar :imageUrl="account.croppedPhoto" :photoStatus="account.profilePhotoStatus" size="mega" :name="sitterName" />
      <a
        class="primary-focus flex justify-center items-center w-32 h-32 rounded-full bg-grey-divider-subdued !absolute top-64 right-0"
        href="/sitter/photo_upload#/sitter_upload"
        :aria-label="noProfilePhoto ? 'Add profile photo' : 'Edit profile photo'"
      >
        <AddIcon v-if="noProfilePhoto || account.profilePhotoStatus === 'rejected'" :width="32" :height="32" />
        <PhotoIcon v-else :width="16" :height="16" color="#4B4C52" />
      </a>
    </div>
  </section>
</template>

<script lang="ts">
import { Account } from '@/models/account';
import ProfileEditMenu from './ProfileEditMenu.vue';
import Avatar from '@/components/avatar/Avatar.vue';
import PhotoIcon from '@/graphics/icons/PhotoIcon.vue';
import AddIcon from '@/graphics/icons/AddIcon.vue';

// GraphQL
import { ACCOUNT_PROFILES_QUERY } from '@/graphql/account/provider/queries';

export default {
  name: 'ProfileEdit',
  components: { ProfileEditMenu, Avatar, PhotoIcon, AddIcon },
  props: {
    account: {
      required: true,
      type: Account,
    },
  },
  data(): any {
    return {
      profileAccountData: { id: this.account?.id },
    };
  },
  computed: {
    sitterName(): string {
      return `${this.account?.firstName} ${this.account?.lastName}`;
    },
    noProfilePhoto(): boolean {
      return !this.account.croppedPhoto;
    },
  },
  mounted() {
    this.fetchAccountProfiles();
  },
  methods: {
    fetchAccountProfiles() {
      this.$apollo
        .query({
          query: ACCOUNT_PROFILES_QUERY,
          variables: { accountId: this.account.id },
        })
        .then(({ data }) => {
          this.profileAccountData = { ...this.profileAccountData, ...data.account };
        })
        .catch((error) => {
          // Handle error appropriately
          console.error('Error fetching account profiles:', error);
        });
    },
  },
};
</script>
